import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { NavBar, Toast, Dialog, Skeleton, List, Tag, Button, Tabs, Empty } from 'react-vant';
import { ArrowLeft, Success, Cross, ChatO } from '@react-vant/icons';
import { getAllLeaveRequests, reviewLeaveRequest } from '../../../api/club';
import dayjs from 'dayjs';

const ClubLeaveReview = () => {
  const navigate = useNavigate();
  const { sessionId } = useParams();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('pending');

  useEffect(() => {
    fetchRequests();
  }, [sessionId]);

  const fetchRequests = async () => {
    try {
      setLoading(true);
      const res = await getAllLeaveRequests(sessionId ? { session_id: sessionId } : {});
      setRequests(res || []);
    } catch (error) {
      Toast.fail('获取申请列表失败');
    } finally {
      setLoading(false);
    }
  };

  const handleReview = async (id, status) => {
    const statusText = status === 'approved' ? '同意' : '驳回';
    Dialog.confirm({
      title: '审核确认',
      message: `确定要${statusText}该请假申请吗？`,
      onConfirm: async () => {
        try {
          await reviewLeaveRequest(id, { 
            status, 
            review_comment: status === 'rejected' ? '由教师移动端快速驳回' : '同意' 
          });
          Toast.success('处理成功');
          fetchRequests();
        } catch (error) {
          Toast.fail('处理失败');
        }
      }
    });
  };

  const filteredRequests = requests.filter(r => {
    if (activeTab === 'pending') return r.status === 'pending';
    return r.status !== 'pending';
  });

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <NavBar 
        title={<span style={{ fontWeight: 800 }}>请假审核</span>} 
        leftText={<ArrowLeft size={20} />} 
        onClickLeft={() => navigate(-1)}
        fixed
        placeholder
      />

      <Tabs active={activeTab} onChange={setActiveTab} sticky offsetTop={46}>
        <Tabs.TabPane name="pending" title={`待处理 (${requests.filter(r => r.status === 'pending').length})`} />
        <Tabs.TabPane name="history" title="审核记录" />
      </Tabs>

      <div style={{ padding: '16px' }}>
        {loading ? (
          <Skeleton title row={10} />
        ) : filteredRequests.length === 0 ? (
          <Empty description="暂无相关请假申请" />
        ) : (
          filteredRequests.map(item => (
            <div 
              key={item.id}
              style={{
                background: '#fff',
                borderRadius: '16px',
                padding: '20px',
                marginBottom: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.03)'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '18px', fontWeight: 800, color: '#0f172a' }}>{item.student_name}</span>
                  <Tag type="primary" plain size="small">{item.club_name}</Tag>
                </div>
                <Tag type={item.status === 'pending' ? 'warning' : (item.status === 'approved' ? 'success' : 'danger')}>
                  {item.status === 'pending' ? '待审核' : (item.status === 'approved' ? '已同意' : '已驳回')}
                </Tag>
              </div>

              <div style={{ fontSize: '14px', color: '#64748b', lineHeight: '1.6', marginBottom: '16px' }}>
                <div style={{ display: 'flex', gap: '4px' }}>
                  <span style={{ color: '#94a3b8', flexShrink: 0 }}>请假日期：</span>
                  <span>{dayjs(item.leave_date).format('YYYY年MM月DD日')}</span>
                </div>
                <div style={{ display: 'flex', gap: '4px' }}>
                  <span style={{ color: '#94a3b8', flexShrink: 0 }}>原因：</span>
                  <span>{item.reason || '未填写'}</span>
                </div>
              </div>

              {item.status === 'pending' && (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', borderTop: '1px solid #f8fafc', paddingTop: '16px' }}>
                  <Button 
                    size="small" 
                    icon={<Cross />} 
                    onClick={() => handleReview(item.id, 'rejected')}
                    style={{ borderRadius: '8px' }}
                  >
                    驳回
                  </Button>
                  <Button 
                    type="primary" 
                    size="small" 
                    icon={<Success />} 
                    onClick={() => handleReview(item.id, 'approved')}
                    style={{ borderRadius: '8px' }}
                  >
                    同意
                  </Button>
                </div>
              )}

              {item.status !== 'pending' && item.review_comment && (
                <div style={{ fontSize: '12px', color: '#94a3b8', background: '#f8fafc', padding: '10px', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
                    <ChatO /> 审核备注
                  </div>
                  {item.review_comment}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ClubLeaveReview;
